<template>
  <v-text-field
    v-model="priceValue"
    v-money="vMoney"
    :label="label"
    :messages="message"
    :disabled="disabled"
    outlined
    height="44px"
    :prefix="removePrefix ? '' : 'R$'"
    :error="validationError"
    :error-messages="validationMessage"
    @keydown="$event.key === '-' ? $event.preventDefault() : null"
  />
</template>

<script>
import { VMoney } from 'v-money'
import { localeString } from '@/config/helpers.js'

export default {
  name: 'ProductStorePriceInput',
  directives: { money: VMoney },
  components: {},
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    validationError: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validationMessage: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    removePrefix: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    price: 0,
    locale: localeString,
    vMoney: { decimal: ',', thousands: '.', precision: 2, masked: false },
  }),
  computed: {
    priceValue: {
      get() {
        return this.locale(this.value, 2)
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  mounted() {
    this.price = this.locale(this.value, 2)
  },
  methods: {},
}
</script>

<style lang="scss"></style>
